import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TempRemaService {
  // private apiUrl = "http://localhost:3003/api/tempRema";
   private apiUrl = "https://lexipackghana.com:3003/api/tempRema";

  constructor(private http: HttpClient) {}
  addTempRema(data:any){
    return this.http.post(this.apiUrl+'/addTempRema',data);
  }
  getTempRema(){
    return this.http.get(this.apiUrl+'/getAllTempRema');
  }
  getTempRemaById(id: string) {
    return this.http.get(this.apiUrl + '/' + id);
  }
  updateTempRema(id: string, data: any) {
    return this.http.put(this.apiUrl + '/' + id, data);
  }
}
